module.exports = __webpack_public_path__ + "static/media/delete_icon.873475d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/delete_icon.png
// module id = 519
// module chunks = 0